import { isOk } from '@/common/utils';
import { graphqlRequest } from '../urql';
import { getUserBackgroundQuery, getUserClipArtQuery } from './queries';
import { PER_PAGE_10 } from '@/common/constants';
import { get } from 'lodash';
import { mapBackgrounds } from './api_mutation';

export const getGeneratedBackgroundApi = async (pageType, page, hideSpiner) => {
  const res = await graphqlRequest(
    getUserBackgroundQuery,
    { pageType, page, perPages: PER_PAGE_10 },
    hideSpiner
  );

  if (!isOk(res)) return;
  const backgrounds = get(res, 'data.user_backgrounds_page_type', []);

  return mapBackgrounds(backgrounds);
};

export const getGeneratedClipartApi = async (page, hideSpiner) => {
  const res = await graphqlRequest(
    getUserClipArtQuery,
    { page, perPages: PER_PAGE_10 },
    hideSpiner
  );

  if (!isOk(res)) return;
  const cliparts = get(res, 'data.user_cliparts', []);

  return cliparts.map(c => ({ ...c, imageUrl: c.large_url }));
};
